<template>
    <div>
        <a-form 
            ref="formRef"
            :layout="form.layout"
            :label-col="form.labelCol" 
            :wrapper-col="form.wrapperCol" 
            labelAlign="right"
        >
            <div v-for="(item,index) in form.formField" :key="index" :style="{display:item.display? item.display : 'inline-block', marginRight:'10px'}">
                <!-- 单行文本 -->
                <a-form-item :label="item.name_lang? $t(item.name_lang) : ''" :class="{'noLabel':item.isChild}" v-if="item.type === 'input'" :required="item.required">
                    <a-input 
                        v-model:value="form.formData[`${item.key}`]" 
                        :style="{'width':item.width? item.width : '230px' }"
                        :class="{'childInputClass':item.isChild}"
                        :placeholder="$t(item.placeholder_lang)" 
                        :disabled="item.disabled"
                        :show-count="item.showCount"
                        :allowClear="item.allowClear"
                        :maxlength="item.maxlength"
                        :addon-before="item.addonBefore"
                        @change="handleInputChange"
                    />
                    <a-button type="primary" size="small" style="margin:4px 0 0 10px" v-if="item.showAddBtn" @click="handleBtnClick('add',item)">+</a-button>
                    <a-button type="primary" size="small" ghost style="margin:4px 0 0 10px" :disabled="item.removeBtnDisabled" v-if="item.showRemoveBtn" @click="handleBtnClick('remove',item)">-</a-button>
                </a-form-item>
                <!-- 带有搜索按钮的输入框 -->
                <a-form-item :label="item.name_lang? $t(item.name_lang) : ''" v-if="item.type === 'inputSearch'" :required="item.required">
                    <a-input-search
                        v-model:value="form.formData[`${item.key}`]" 
                        :style="{'width':item.width? item.width : '230px' }"
                        enter-button
                        :allowClear="item.allowClear"
                        :placeholder="$t(item.placeholder_lang)" 
                        @search="handleInputSearch"
                    />
                </a-form-item>
                <!-- 多行文本 -->
                <a-form-item :label="item.name_lang? $t(item.name_lang) : ''" v-if="item.type === 'textarea'" :required="item.required">
                    <a-textarea 
                        v-model:value="form.formData[`${item.key}`]" 
                        :style="{'width':item.width? item.width : '700px' }"
                        :placeholder="item.placeholder" 
                        :disabled="item.disabled"
                        :readonly="item.readonly"
                        :allowClear="item.allowClear"
                        :rows="item.rows? item.rows : 8" 
                        @change="handleTextareaChange"
                    />
                </a-form-item>
                <!-- 数字输入框 -->
                <a-form-item :label="$t(item.name_lang)" v-if="item.type === 'inputNumber'" :required="item.required">
                    <a-input-number 
                        v-model:value="form.formData[`${item.key}`]" 
                        :style="{'width':item.width? item.width : '230px' }"
                        :min="item.min" 
                        :max="item.max" 
                        :disabled="item.disabled"
                        @change="handleInputNumberChange"
                    />
                </a-form-item>
                <!-- 单选下拉 -->
                <a-form-item :label="item.name_lang? $t(item.name_lang) : ''" v-if="item.type === 'select'" :required="item.required">
                    <a-select
                        v-model:value="form.formData[`${item.key}`]"
                        :style="{'width': item.width? item.width : '230px'}"
                        :disabled="item.disabled"
                        :allowClear="item.allowClear"
                        :mode="item.mode? item.mode : ''"
                        :placeholder="$t(item.placeholder_lang)"
                        show-search
                        @focus="handleSelectFocus"
                        @change="handleSelectChange"
                        @search="handleFetchSearch"
                    >
                        <a-select-option 
                            v-for="(opt,oIndex) in item.options" 
                            :key="oIndex" 
                            :value="opt.value"
                            :disabled="opt.disabled"
                        >
                            {{ $t(`${opt.label}`) }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <!-- radio组 -->
                <a-form-item :label="$t(item.name_lang)" v-if="item.type === 'radio'" :required="item.required">
                    <a-radio-group 
                        v-model:value="form.formData[`${item.key}`]"
                        :options="item.options" 
                        @change="handleChangeRadio"
                    />
                </a-form-item>
                <!-- 日期 -->
                <a-form-item :label="$t(item.name_lang)" v-if="item.type === 'date'" :required="item.required">
                    <a-date-picker 
                        v-model:value="form.formData[`${item.key}`]"
                        :picker="item.picker" 
                        :allowClear="item.allowClear"
                    />
                </a-form-item>
                <!-- 日期范围 -->
                <a-form-item :label="item.name_lang? $t(item.name_lang) : ''" v-if="item.type === 'dateRange'" :required="item.required">
                    <a-range-picker 
                        v-if="item.disabledDate"
                        :value="form.formData[`${item.key}`]"
                        :format="item.format"
                        :disabled-date="disabledDate"
                        :style="{'width':item.width? item.width : '250px' }"
                        @change="onDateChange"
                        @openChange="onDateOpenChange"
                        @calendarChange="onDateCalendarChange"
                    />
                    <a-range-picker 
                        v-if="!item.disabledDate"
                        v-model:value="form.formData[`${item.key}`]"
                        :format="item.format"
                        :style="{'width':item.width? item.width : '250px' }"
                        @change="onDateChange"
                    />
                </a-form-item>
                <!-- 自动完成 -->
                <a-form-item :label="$t(item.name_lang)" v-if="item.type === 'autoComplete'" :required="item.required">
                    <a-auto-complete
                        v-model:value="form.formData[`${item.key}`]"
                        :options="item.options"
                        :style="{width: item.width? item.width : '230px'}"
                        :placeholder="item.placeholder"
                        :allowClear="item.allowClear"
                        @select="handleAutoCompleteSelect"
                        @search="handleAutoCompleteSearch"
                    />
                </a-form-item>
                <!-- 上传文件 -->
                <a-form-item :label="$t(item.name_lang)" v-if="item.type === 'upload'" :required="item.required">
                    <a-upload
                        class="uploadFirmware"
                        v-model:file-list="fileList"
                        name="file"
                        action=""
                        :accept="item.accept"
                        :maxCount="item.maxCount"
                        @change="handleChangeUpLoad"
                    >
                        <a-button>{{$t('base.selectFile')}}</a-button>
                    </a-upload>
                </a-form-item>
                <!-- 上传图片 -->
                <a-form-item :label="item.name_lang? $t(item.name_lang) : ''" v-if="item.type === 'uploadImg'" :required="item.required">
                    <UploadImg 
                        class="uploadImg" 
                        :data="item.uploadImgData" 
                        @uploadChange="uploadChange" 
                        @uploadRemove="uploadRemove(item)"
                        @click="clickUploadImg(item)"
                    ></UploadImg>
                </a-form-item>
                <!-- 自定义插槽 -->
                <slot name="customField" :props="item"></slot>


            </div>
             <!-- 自定义插槽 -->
             <slot name="formSlot"></slot>
        </a-form>
    </div>
</template>

<script setup>
    import { ref,reactive } from "vue";
    import UploadImg from "@/components/UploadImg.vue";

    const props = defineProps({
        form:{
            type:Object,
        },
        disabledDateRange:{ // 可选日期的最大范围
            type:Number
        }
    })

    const fileList = ref([]);
    const formRef = ref()
    const dates = ref()
    const clickItem = ref(null)

    const emits = defineEmits([
        'handleInputChange',
        'handleTextareaChange',
        'handleInputNumberChange',
        'handleSelectFocus',
        'handleSelectChange',
        'handleFetchSearch',
        'handleAutoCompleteSelect',
        'handleAutoCompleteSearch',
        'handleChangeUpLoad',
        'handleAddBtnClick',
        'handleRemoveBtnClick',
        'uploadChange',
        'uploadRemove',
        'handleInputSearch',
        'handleDateChange',
        'handleChangeRadio',
    ])

    const uploadChange =(file, fileList)=>{
        // console.log(file, fileList, clickItem.value,'file, fileList')
        emits('uploadChange',file, fileList,clickItem.value)
    }

    const clickUploadImg = (item)=>{
        clickItem.value = item
    }

    const uploadRemove = (item)=>{
        // console.log(item,'iikkll')
        emits('uploadRemove',item)
    }

    const handleBtnClick = (type,item)=>{
        type == 'add'? emits('handleAddBtnClick',item) :  emits('handleRemoveBtnClick',item)
    }

    // const filterOption = (input, option) => {
    //     // console.log(input,'vv',option)
    //     return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    // };

    function handleInputChange(val){
        // console.log(val,'vvvv')
        emits('handleInputChange',val.target.value)
    }

    function handleInputSearch(searchValue){
        emits('handleInputSearch',searchValue)
    }

    function handleTextareaChange(val){
        // console.log(val,'vvvv222')
        emits('handleTextareaChange',val.target.value)
    }

    function handleInputNumberChange(val){
        // console.log(val,'vvvv33333')
        emits('handleInputNumberChange',val.target.value)
    }

    function handleSelectFocus(val){
        // console.log(val,'vvvv444')
        emits('handleSelectFocus',val.target.value)
    }

    function handleSelectChange(val,opt){
        console.log(val,'vvvv55')
        emits('handleSelectChange',val)
    }

    function handleFetchSearch(val){
        console.log(val,'vvvvssss')
        emits('handleFetchSearch',val)
    }

    function handleAutoCompleteSelect(val){
        console.log(val,'vvvv666')
        emits('handleAutoCompleteSelect',val.target.value)
    }

    function handleAutoCompleteSearch(val){
        console.log(val,'vvvv777')
        emits('handleAutoCompleteSearch',val)
    }

    function handleChangeUpLoad(info){
        emits('handleChangeUpLoad',info.file.originFileObj)
        // console.log(info.file.originFileObj,'originFileObj')
    }

    function handleChangeRadio(e){
        // console.log(e.target.value,'val')
        emits('handleChangeRadio')
    }

    // 日期选择限制选择范围
    function onDateChange(val){
        props.form.formData.date = val
        emits('handleDateChange',val)
    }

    function onDateOpenChange(open){
        if (open) {
            dates.value = []
            props.form.formData.date = []
        }
    }

    function onDateCalendarChange(val){
        dates.value = val
    }

    function disabledDate(current){
        if (!dates.value || dates.value.length === 0) {
            return false
        }

        const dateRange = props.disabledDateRange? props.disabledDateRange : 15
        const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') >= dateRange
        const tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') >= dateRange
        return tooEarly || tooLate
    }

    defineExpose({
        fileList
    })

</script>

<style lang="scss" scoped>
::v-deep .ant-select{
    width: 230px;
}

.uploadFirmware{
    ::v-deep .anticon-delete{
        display: none;
    }

    ::v-deep .ant-upload-list-item-name,
    ::v-deep .anticon-paper-clip{
        color: #1890ff;
    }

    ::v-deep .ant-upload-list-item-name{
        overflow: visible;
    }
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.childInputClass{
    // margin-left: 200px;
    // width: 90%;
}
</style>